import {
  instance as axios,
  setJwtToken,
  setMultiPartHeader,
} from "../../config/AxiosInstance";

//----------------Repost API----------------
export const reportApi = async (data) => {
  const endPoint = `user/report`;
  return await axios.post(endPoint, data, setJwtToken());
};
